const UserRemoveIcon = ({ fill, className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.37435 5.83333C4.37435 3.64721 6.14655 1.875 8.33268 1.875C10.5188 1.875 12.291 3.64721 12.291 5.83333C12.291 8.01946 10.5188 9.79167 8.33268 9.79167C6.14655 9.79167 4.37435 8.01946 4.37435 5.83333ZM8.33268 3.125C6.83691 3.125 5.62435 4.33756 5.62435 5.83333C5.62435 7.3291 6.83691 8.54167 8.33268 8.54167C9.82845 8.54167 11.041 7.3291 11.041 5.83333C11.041 4.33756 9.82845 3.125 8.33268 3.125Z"
        fill={fill || "#D1A855"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00018 12.2078C6.65284 10.653 10.0128 10.653 12.6655 12.2078C12.7495 12.257 12.8541 12.3151 12.9731 12.3812C13.5003 12.6738 14.3103 13.1234 14.8648 13.6577C15.211 13.9913 15.5523 14.4419 15.6146 15.0031C15.6814 15.6044 15.4128 16.1592 14.8992 16.6409C14.0241 17.4615 12.9675 18.125 11.5989 18.125H5.06682C3.6982 18.125 2.6416 17.4615 1.76653 16.6409C1.25293 16.1592 0.984307 15.6044 1.05108 15.0031C1.11339 14.4419 1.45468 13.9913 1.80092 13.6577C2.35541 13.1234 3.16534 12.6738 3.69254 12.3812C3.81143 12.3152 3.91625 12.257 4.00018 12.2078ZM12.0334 13.2862C9.77109 11.9602 6.8946 11.9602 4.63228 13.2862C4.50523 13.3607 4.367 13.4379 4.22293 13.5184C3.69589 13.8128 3.09055 14.1509 2.66823 14.5579C2.40574 14.8108 2.30839 15.0064 2.29344 15.141C2.28295 15.2355 2.29844 15.426 2.62161 15.7291C3.38158 16.4418 4.14599 16.875 5.06682 16.875H11.5989C12.5197 16.875 13.2841 16.4418 14.0441 15.7291C14.3672 15.426 14.3827 15.2355 14.3722 15.141C14.3573 15.0064 14.2599 14.8108 13.9974 14.5579C13.5751 14.1509 12.9699 13.8128 12.4429 13.5184C12.2988 13.4379 12.1605 13.3607 12.0334 13.2862Z"
        fill={fill || "#D1A855"}
      />
      <path
        d="M14.608 3.30806C14.3639 3.06398 13.9682 3.06398 13.7241 3.30806C13.48 3.55214 13.48 3.94786 13.7241 4.19194L15.3655 5.83333L13.7241 7.47472C13.48 7.7188 13.48 8.11453 13.7241 8.35861C13.9682 8.60269 14.3639 8.60269 14.608 8.35861L16.2493 6.71722L17.8907 8.35861C18.1348 8.60269 18.5305 8.60269 18.7746 8.35861C19.0187 8.11453 19.0187 7.7188 18.7746 7.47472L17.1332 5.83333L18.7746 4.19194C19.0187 3.94786 19.0187 3.55214 18.7746 3.30806C18.5305 3.06398 18.1348 3.06398 17.8907 3.30806L16.2493 4.94945L14.608 3.30806Z"
        fill={fill || "#D1A855"}
      />
    </svg>
  );
};

export default UserRemoveIcon;
